<template>
  <div class="reportMonth">
    <header>
      <el-card shadow="never" style="padding-top:20px">
        <el-form inline>
          <el-form-item label="公众号">
            <el-input
              v-model="selectQueryData.wechat_account_name"
              placeholder="请输入关键字"
              clearable
            />
          </el-form-item>
          <el-form-item label="平台">
            <el-select
              v-model="selectQueryData.platform_id"
              placeholder="全部"
              filterable
            >
              <el-option
                v-for="item in selectListData.data ? selectListData.data.platform : null"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              />
            </el-select>
          </el-form-item>
          <el-form-item label="书名">
            <!-- <el-select
              v-model="selectQueryData.novel_id"
              placeholder="全部"
              filterable
            >
              <el-option
                v-for="item in selectListData.data ? selectListData.data.novel : null"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              />
            </el-select> -->
            <el-autocomplete
              v-model="novel_name"
              :fetch-suggestions="querySearchAsync"
              placeholder="请输入小说名称"
              @select="handleSelect"
            />
          </el-form-item>
          <el-form-item v-if="displayType === 'list'" label="主角">
            <el-select
              v-model="selectQueryData.lead_id"
              placeholder="全部"
              filterable
            >
              <el-option
                v-for="item in selectListData.data ? selectListData.data.lead : null"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              />
            </el-select>
          </el-form-item>
          <el-form-item label="投放者">
            <el-select
              v-model="selectQueryData.user_id"
              placeholder="全部"
              filterable
            >
              <el-option
                v-for="item in selectListData.data ? selectListData.data.user : null"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              />
            </el-select>
          </el-form-item>
          <el-form-item label="年份">
            <el-select v-model="selectQueryData.year" placeholder="请选择">
              <el-option
                v-for="item in optionsyear"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              />
            </el-select>
          </el-form-item>
          <el-form-item label="月份">
            <el-select v-model="selectQueryData.month" placeholder="请选择">
              <el-option
                v-for="item in optionsmonth"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              />
            </el-select>
          </el-form-item>
          <el-form-item v-if="displayType === 'chart'" label="投放平台">
            <el-select v-model="selectQueryData.launch_platform_type" placeholder="请选择">
              <el-option
                v-for="item in optionstoufang"
                :key="item.key"
                :label="item.value"
                :value="item.key"
              />
            </el-select>
          </el-form-item>
          <!-- <el-form-item label="年份">
          <el-select placeholder="全部" />
        </el-form-item>
        <el-form-item label="投放版位">
          <el-select placeholder="全部投放版位" />
        </el-form-item> -->
          <el-button
            type="primary"
            icon="el-icon-search"
            @click="handleSearch"
          >搜索</el-button>
          <el-button
            type="primary"
            icon="el-icon-refresh"
            @click="handleReset"
          >重置</el-button>
        </el-form>
      </el-card>
    </header>
    <main v-if="displayType == 'list'">
      <el-card shadow="never" style="padding-top:20px;margin-top:16px">
        <div class="titles">
          <div style="margin-right: 20px">上次更新时间为：{{ updateTime === null ? '0000-00-00 00:00:00' : updateTime }}</div>
          <div>
            <label>书城账号密码</label>
            <label>更新数据</label>
            <label>更新月表数据</label>
          </div>
        </div>
        <div class="form">
          <div class="form-top" style="font-weight:normal">
            <div class="title">
              <span>关键指标明细</span>
              <span style="margin-left: 10px">(</span>
              <span class="aggregateData">总成本：<span class="blue">{{ newdataobj ? newdataobj.account_recharge : 0 }}</span></span>
              <span class="aggregateData">总充值：<span class="blue">{{ newdataobj ? newdataobj.account_recharge : 0 }}</span></span>
              <span class="aggregateData">总回收率：<span class="blue" style="margin:0">{{ newdataobj ? newdataobj.account_recharge: 0 }}%</span> ）</span>
              <span style="margin-left: 10px">首付金额</span>
              <el-switch
                v-model="value"
                :width="40"
                style="margin-left: 10px"
                active-color="#409EFF"
                inactive-color="rgb(191,191,191)"
              />
            </div>
            <div class="table-label">
              <span>
                <img src="../../assets/images/13.小说/Wallet.webp">总充</span>
              <span>
                <img src="../../assets/images/13.小说/Trend.webp">总充回本率</span>
              <span>
                <img src="../../assets/images/13.小说/Bank-card.webp">首冲回本</span>
              <span>
                <img src="../../assets/images/13.小说/Bank-card-two.webp">复充回本</span>
            </div>

          </div>
        </div>
        <el-table
          v-loading="loading"
          :data="tableData"
          border
          :cell-style="cellStyle"
          :header-cell-style="headerCellStyle"
          style="width: 100%;font-weight:normal"
        >
          <el-table-column
            fixed
            prop="month"
            label="日期"
            align="center"
            sortable
            :width="103"
          />
          <el-table-column
            prop="order_money"
            label="累计充值"
            align="center"
            sortable
            :width="103"
          />
          <el-table-column
            prop="account_recharge"
            label="成本"
            align="center"
            sortable
            :width="95"
          />
          <el-table-column
            prop="mcba"
            label="回本率"
            align="center"
            :width="105"
          >
            <template slot-scope="scope">
              <div>{{ scope.row.mcba }}%</div>
            </template>
          </el-table-column>
          <el-table-column
            prop="profit"
            label="利润"
            align="center"
            :width="110"
          />
          <el-table-column
            v-for="(item, index) in tableData ? tableData[0].data : null"
            :key="index"
            :label="'第'+(index + 1)+'月'"
            align="center"
            :min-width="210"
          >
            <template slot-scope="scope">
              <div> <img
                src="../../assets/images/13.小说/Wallet.webp"
                style="width: 16px;margin-right:5px"
              >{{ scope.row.data[index].zc }}</div>
              <div><img
                src="../../assets/images/13.小说/Bank-card.webp"
                style="width: 16px;margin-right:5px"
              >{{ scope.row.data[index].mcb }}</div>
              <div>
                <span class="green"><img
                  src="../../assets/images/13.小说/Bank-card.webp"
                  style="width: 16px;margin-right:5px"
                >{{ scope.row.data[index].scb }}</span>
                <el-divider direction="vertical" />
                <span class="yellow"><img
                  src="../../assets/images/13.小说/Bank-card-two.webp"
                  style="width: 16px;margin-right:5px"
                >{{ scope.row.data[index].fcb }}</span>
              </div>
              <div v-show="value"><span class="green">{{ scope.row.data[index].sc }}</span>
                <el-divider direction="vertical" />
                <span class="yellow">{{ scope.row.data[index].fc }}</span></div>
            </template>
          </el-table-column>
        </el-table>
        <pagination-right
          :total="total"
          :page-sizes="[10]"
          @size-change="fetchPageSize"
          @current-change="fetchCurrentPage"
        />
      </el-card>

      <!-- <pagination :total="total" :page.sync="selectQueryData.page" :limit.sync="pageData.page_size" @pagination="getList" /> -->
    </main>
    <main v-if="displayType == 'chart'">
      <el-card
        shadow="never"
        class="total-box"
        style="padding:20px 0px;"
      >
        <div style="display: flex;align-items: center;justify-content: space-between;">
          <!-- 1. 总成本 -->
          <div class="total-cell">
            <div class="total-img">
              <img
                src="../../assets/images/13.小说/chengben.webp"
                alt=""
              >
            </div>
            <div class="total-data">
              <div>总成本</div>
              <div>
                <span>￥</span>
                <count-to
                  :key="newdataobj ? newdataobj.account_recharge : 0"
                  :start-val="0"
                  :end-val="newdataobj ? Number(newdataobj.account_recharge) : 0"
                  :duration="1500"
                  :decimals="0"
                />
              </div>
            </div>
          </div>

          <!-- 2. 总充值 -->
          <div class="total-cell">
            <div class="total-img">
              <img
                src="../../assets/images/13.小说/chongzhi.webp"
                alt=""
              >
            </div>
            <div class="total-data">
              <div>总充值</div>
              <div>
                <span>￥</span>
                <count-to
                  :key="newdataobj ? newdataobj.order_money : 0"
                  :start-val="0"
                  :end-val="newdataobj ? Number(newdataobj.order_money) : 0"
                  :duration="1500"
                  :decimals="0"
                />
              </div>
            </div>
          </div>

          <!-- 3. 总回本率 (百分比，保留2位小数) -->
          <div class="total-cell">
            <div class="total-img">
              <img
                src="../../assets/images/13.小说/huiben.webp"
                alt=""
              >
            </div>
            <div class="total-data">
              <div>总回收率</div>
              <div>
                <!-- <count-to
                  :key="newdataobj ? newdataobj.tcbi : 0"
                  :start-val="0"
                  :end-val="newdataobj ? Number(newdataobj.tcbi) : 0"
                  :duration="1500"
                  :decimals="2"
                /> -->
                <div v-if="newdataobj">
                  {{ newdataobj.tcbi }}
                </div>
                <!-- <span>%</span> -->
              </div>
            </div>
          </div>

          <!-- 4. 增长率 (百分比，保留2位小数) -->
          <!-- <div class="total-cell">
            <div class="total-img">
              <img
                src="../../assets/images/13.小说/zengzhang.png"
                alt=""
              >
            </div>
            <div class="total-data">
              <div>增长率</div>
              <div>
                <count-to
                  :key="data ? data.ir : 0"
                  :start-val="0"
                  :end-val="data ? Number(data.ir) : 0"
                  :duration="1500"
                  :decimals="2"
                />
                <span>%</span>
              </div>
            </div>
          </div> -->
        </div>
      </el-card>
      <el-card shadow="never" style="padding:20px 0px;">
        <div class="form">
          <div class="form-top" style="font-weight:normal">
            <div class="title">
              <span>关键指标明细</span>
              <span style="margin-left: 10px">(</span>
              <span class="aggregateData">总成本：<span class="blue">{{ newdataobj ? newdataobj.account_recharge : 0 }}</span></span>
              <span class="aggregateData">总充值：<span class="blue">{{ newdataobj ? newdataobj.account_recharge : 0 }}</span></span>
              <span class="aggregateData">总回收率：<span class="blue" style="margin:0">{{ newdataobj ? newdataobj.account_recharge: 0 }}%</span> ）</span>
              <span style="margin-left: 10px">首付金额</span>
              <el-switch
                v-model="value"
                :width="40"
                style="margin-left: 10px"
                active-color="#409EFF"
                inactive-color="rgb(191,191,191)"
              />

            </div>
            <div class="table-label">
              <span>
                <img src="../../assets/images/13.小说/Wallet.webp">总充</span>
              <span>
                <img src="../../assets/images/13.小说/Trend.webp">总充回本率</span>
              <span>
                <img src="../../assets/images/13.小说/Bank-card.webp">首冲回本</span>
              <span>
                <img src="../../assets/images/13.小说/Bank-card-two.webp">复充回本</span>
            </div>
          </div>
        </div>
        <el-table
          :data="newdata"
          border
          style="width: 100%;font-weight:normal"
          :cell-style="cellStyle"
          :header-cell-style="headerCellStyle"
        >
          <el-table-column
            fixed
            prop="date"
            label="日期"
            align="center"
            sortable
            :width="103"
          />
          <el-table-column
            prop="order_money"
            label="累计充值"
            align="center"
            sortable
            :width="103"
          />
          <el-table-column
            prop="account_recharge"
            label="成本"
            align="center"
            sortable
            :width="95"
          />
          <el-table-column
            prop="tcbi"
            label="回本率"
            align="center"
            :width="105"
          >
            <template slot-scope="scope">
              <div>{{ scope.row.tcbi }}</div>
            </template>
          </el-table-column>
          <el-table-column
            prop="profitability"
            label="利润"
            align="center"
            :width="110"
          />
          <el-table-column
            v-for="(item, index) in newdata ? newdata[0].data : []"
            :key="index"
            :label="'第'+(index + 1)+'月'"
            align="center"
            :min-width="210"
          >
            <template slot-scope="scope">
              <div>
                <img
                  src="../../assets/images/13.小说/Wallet.webp"
                  style="width: 16px;margin-right:5px"
                >
                {{ scope.row.data[index].zc }}
              </div>
              <div> <img
                src="../../assets/images/13.小说/Trend.webp"
                style="width: 16px;margin-right:5px"
              >{{ scope.row.data[index].tcb }}</div>
              <div><span class="green"><img
                     src="../../assets/images/13.小说/Bank-card.webp"
                     style="width: 16px;margin-right:5px"
                   >{{ scope.row.data[index].scb }}</span>
                <el-divider direction="vertical" />
                <span><img
                  src="../../assets/images/13.小说/Bank-card-two.webp"
                  style="width: 16px;margin-right:5px"
                >{{ scope.row.data[index].fcb }}</span></div>
              <div v-show="value">
                <span class="green">{{ scope.row.data[index].sc }}</span>
                <el-divider direction="vertical" />
                <span class="yellow">{{ scope.row.data[index].fc }}</span>
              </div>
            </template>
          </el-table-column>
        </el-table>
        <pagination-right
          :total="newcount"
          :page-sizes="[10]"
          @size-change="fetchPageSizer"
          @current-change="fetchCurrentPager"
        />
      </el-card>

      <!-- 图表容器 （示例4个） -->
      <div class="chart-layout">
        <div ref="chart1" class="chart-item" />
        <div ref="chart2" class="chart-item" />
        <div ref="chart3" class="chart-item" />
        <div ref="chart4" class="chart-item" />
        <div style="width: 100%;text-align: right;padding:0px 16px; border-radius:8px;background-color: #FFFFFF;position:relative">
          <el-select v-model="monthIndex" placeholder="请选择" style="position:absolute;top:16px;right:24px;z-index:999;width:124px" @change="sewqawr">
            <el-option
              v-for="item in options"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            />
          </el-select>
          <div ref="chart5" style="width: 100%; height: 360px;background: #fff;" />
        </div>
      </div>
    </main>
  </div>
</template>

<script>
// import Pagination from '@/components/Pagination'
import PaginationRight from '@/components/PaginationRight'
import { getList } from '@/api/report/reportMonth'
import { getSelectList } from '@/api/report/SelectData.js'
import { preditmonthv2, preditmonthgraphics } from '@/api/releaseGroup.js'
import * as echarts from 'echarts'
import CountTo from 'vue-count-to'
import dialogFocus from '@/layout/mixin/dialogFocus'
import { getFictionList, commonreportoptions } from '@/api/copyReleaseGroup.js'
export default {
  name: 'ReportMonth',
  components: {
    // Pagination,
    PaginationRight,
    CountTo
  },
  mixins: [dialogFocus],
  props: {
    displayType: {
      type: String,
      default: 'list'
    }
  },
  data() {
    const currentYear = new Date().getFullYear()
    return {
      selectListData: [], // 筛选列表数据
      selectQueryData: { // 请求数据
        wechat_account_name: null,
        platform_id: null,
        novel_id: null,
        lead_id: null,
        user_id: null,
        page: 1,
        year: new Date().getFullYear(),
        month: new Date().getMonth() + 1,
        launch_platform_type: ''
      },
      total: 0,
      updateTime: null,
      value: false,
      loading: false,
      searchForm: [],
      tableData: null,
      data: null,
      newdata: [],
      newcount: null,
      newdataobj: null,
      chart1: null,
      chart2: null,
      chart3: null,
      chart4: null,
      chart5: null,
      options: [{
        value: 1,
        label: '1月'
      }, {
        value: 2,
        label: '2月'
      }, {
        value: 3,
        label: '3月'
      }, {
        value: 4,
        label: '4月'
      }, {
        value: 5,
        label: '5月'
      }, {
        value: 6,
        label: '6月'
      }, {
        value: 7,
        label: '7月'
      }, {
        value: 8,
        label: '8月'
      }, {
        value: 9,
        label: '9月'
      }, {
        value: 10,
        label: '10月'
      }, {
        value: 11,
        label: '11月'
      }, {
        value: 12,
        label: '12月'
      }],
      monthIndex: 1,
      optionsyear: Array.from({ length: 10 }, (_, i) => {
        const year = currentYear - i
        return {
          value: year,
          label: `${year}年`
        }
      }),
      optionsmonth: [
        {
          value: 12,
          label: '12月'
        }, {
          value: 11,
          label: '11月'
        }, {
          value: 10,
          label: '10月'
        }, {
          value: 9,
          label: '9月'
        }, {
          value: 8,
          label: '8月'
        }, {
          value: 7,
          label: '7月'
        }, {
          value: 6,
          label: '6月'
        }, {
          value: 5,
          label: '5月'
        }, {
          value: 4,
          label: '4月'
        }, {
          value: 3,
          label: '3月'
        }, {
          value: 2,
          label: '2月'
        }, {
          value: 1,
          label: '1月'
        }
      ],
      optionstoufang: [],
      novel_name: null
    }
  },
  watch: {
    displayType(newVal, oldVal) {
      console.log('displayType changed from', oldVal, 'to', newVal)
      // 根据需要执行的逻辑
      // eslint-disable-next-line eqeqeq
      if (newVal == 'chart') {
        this.selectQueryData.page = 1
        this.newlist()
        this.newtubiao()
      } else {
        this.selectQueryData.page = 1
        this.getList()
      }
    }
  },
  created() {
    console.log('1111')
    this.getSelectListData()
    this.oplistr()
    // this.getList()
  },
  methods: {
    // 获取筛选列表
    getSelectListData() {
      getSelectList().then(res => {
        this.selectListData = res
      })
    },
    getList() {
      this.disposeAllCharts()
      this.loading = true
      getList(this.selectQueryData)
        .then(response => {
          this.tableData = response.data.list
          this.total = response.data.page_info.total
          this.page = response.data.page_info.page
          this.page_size = response.data.page_info.page_size
          this.updateTime = response.data.last_modify_time
          this.data = response.data.list[0]
          this.loading = false
        })
    },
    fetchPageSize(e) {
      console.log(e)
    },
    fetchCurrentPage(e) {
      this.selectQueryData.page = e
      this.getList()
    },
    fetchPageSizer(e) {
      console.log(e)
    },
    fetchCurrentPager(e) {
      this.selectQueryData.page = e
      this.newlist()
    },
    // 搜索按钮
    handleSearch() {
      this.selectQueryData.page = 1
      // eslint-disable-next-line eqeqeq
      if (this.displayType == 'list') {
        this.getList()
      } else {
        this.newlist()
        setTimeout(() => {
          this.newtubiao()
        }, 1000)
      }
    },
    // 重置按钮
    handleReset() {
      this.selectQueryData = {
        wechat_account_name: null,
        platform_id: null,
        novel_id: null,
        lead_id: null,
        user_id: null,
        page: 1,
        year: new Date().getFullYear(),
        month: new Date().getMonth() + 1,
        launch_platform_type: ''
      }
      this.novel_name = null
      // eslint-disable-next-line eqeqeq
      if (this.displayType == 'list') {
        this.getList()
      } else {
        this.newlist()
        setTimeout(() => {
          this.newtubiao()
        }, 1000)
      }
    },
    allday() {
      // eslint-disable-next-line eqeqeq
      if (this.displayType == 'list') {
        this.getList()
      } else {
        this.newlist()
        setTimeout(() => {
          this.newtubiao()
        }, 1000)
      }
    },
    newlist() {
      preditmonthv2(this.selectQueryData).then((res) => {
        console.log('数据', res)
        this.newdata = res.data.list
        this.newcount = res.data.count
        this.newdataobj = res.data.list[0]
      })
    },
    newtubiao() {
      preditmonthgraphics({ ...this.selectQueryData }).then((res) => {
        console.log('图形数据', res.data.data)
        this.disposeAllCharts()

        this.$nextTick(() => {
          // 图1: 累计充值（元）
          if (this.$refs.chart1) {
            console.log('this.$refs.chart1', this.$refs.chart1)
            this.chart1 = echarts.init(this.$refs.chart1)
            this.chart1.setOption(this.getRechargeOptionr(res.data.data.total_cumulative_recharge))
          }

          // 图2: 成本（元）
          if (this.$refs.chart2) {
            this.chart2 = echarts.init(this.$refs.chart2)
            this.chart2.setOption(this.getCostOptionuser(res.data.data.account_recharge))
          }

          // 图3: 利润（元）
          if (this.$refs.chart3) {
            this.chart3 = echarts.init(this.$refs.chart3)
            this.chart3.setOption(this.getProfitOptionr(res.data.data.profitability))
          }

          // 图4: 回本率（%）
          if (this.$refs.chart4) {
            this.chart4 = echarts.init(this.$refs.chart4)
            this.chart4.setOption(this.getRateOptionrlu(res.data.data.rate_of_return))
          }
          // 图4: 回本率（%）
          if (this.$refs.chart5) {
            this.chart5 = echarts.init(this.$refs.chart5)
            // month 为数字，比如 7
            const option = this.getMonthlyChartOptionda(this.monthIndex, res.data.data)
            this.chart5.setOption(option)
          }
        })
      })
    },
    disposeAllCharts() {
      if (this.chart1) {
        this.chart1.dispose()
        this.chart1 = null
      }
      if (this.chart2) {
        this.chart2.dispose()
        this.chart2 = null
      }
      if (this.chart3) {
        this.chart3.dispose()
        this.chart3 = null
      }
      if (this.chart4) {
        this.chart4.dispose()
        this.chart4 = null
      }
      if (this.chart5) {
        this.chart5.dispose()
        this.chart5 = null
      }
      window.removeEventListener('resize', this.handleResize)
    },
    handleResize() {
      this.chart1 && this.chart1.resize()
      this.chart2 && this.chart2.resize()
      this.chart3 && this.chart3.resize()
      this.chart4 && this.chart4.resize()
      this.chart5 && this.chart5.resize()
    },
    getRechargeOptionr(total_cumulative_recharge) {
      const xData = total_cumulative_recharge.map(item => item.name)
      const yData = total_cumulative_recharge.map(item => Number(item.value)) // 转为数字

      return {
        title: { text: '累计充值（元）' },
        tooltip: { trigger: 'axis' },
        xAxis: {
          type: 'category',
          data: xData,
          axisLine: { lineStyle: { color: '#E0E0E0' }},
          axisTick: { show: false },
          splitLine: { show: false }
        },
        yAxis: {
          type: 'value',
          axisLine: { show: false },
          axisTick: { show: false },
          splitLine: {
            lineStyle: {
              type: 'dashed',
              color: '#E0E0E0'
            }
          }
        },
        grid: {
          left: 40,
          right: 20,
          top: 40,
          bottom: 30
        },
        series: [
          {
            name: '充值',
            type: 'line',
            smooth: false,
            symbol: 'circle',
            symbolSize: 6,
            data: yData,
            lineStyle: {
              width: 2,
              color: '#008DFF'
            },
            itemStyle: {
              color: '#008DFF',
              borderColor: '#fff',
              borderWidth: 1
            },
            areaStyle: {
              color: new echarts.graphic.LinearGradient(
                0, 0, 0, 1,
                [
                  { offset: 0, color: 'rgba(0,141,255,0.4)' },
                  { offset: 1, color: 'rgba(0,141,255,0)' }
                ],
                false
              )
            },
            label: {
              // show: true,
              // formatter: '{c}元'
              show: false
            }
          }
        ]
      }
    },
    getCostOptionuser(account_recharge) {
      const xData = account_recharge.map(item => item.name)
      const yData = account_recharge.map(item => Number(item.value)) // 转为数字

      return {
        title: { text: '成本（元）' },
        tooltip: { trigger: 'axis' },
        xAxis: {
          type: 'category',
          data: xData,
          axisLine: { lineStyle: { color: '#E0E0E0' }},
          axisTick: { show: false },
          splitLine: { show: false }
        },
        yAxis: {
          type: 'value',
          axisLine: { show: false },
          axisTick: { show: false },
          splitLine: {
            lineStyle: {
              type: 'dashed',
              color: '#E0E0E0'
            }
          }
        },
        grid: {
          left: 40,
          right: 20,
          top: 40,
          bottom: 30
        },
        series: [
          {
            name: '成本',
            type: 'line',
            smooth: false,
            symbol: 'circle',
            symbolSize: 6,
            data: yData,
            lineStyle: {
              width: 2,
              color: '#5FE1E0'
            },
            itemStyle: {
              color: '#5FE1E0',
              borderColor: '#fff',
              borderWidth: 1
            },
            areaStyle: {
              color: new echarts.graphic.LinearGradient(
                0, 0, 0, 1,
                [
                  { offset: 0, color: 'rgba(95,225,224,0.4)' },
                  { offset: 1, color: 'rgba(95,225,224,0)' }
                ],
                false
              )
            },
            label: {
              // show: true,
              // formatter: '{c}元'
              show: false
            }
          }
        ]
      }
    },
    getProfitOptionr(profitability) {
      const xData = profitability.map(item => item.name)
      const yData = profitability.map(item => Number(item.value)) // 字符串转数字

      return {
        title: { text: '利润（元）' },
        tooltip: { trigger: 'axis' },
        xAxis: {
          type: 'category',
          data: xData,
          axisLine: { lineStyle: { color: '#E0E0E0' }},
          axisTick: { show: false },
          splitLine: { show: false }
        },
        yAxis: {
          type: 'value',
          axisLine: { show: false },
          axisTick: { show: false },
          splitLine: {
            lineStyle: {
              type: 'dashed',
              color: '#E0E0E0'
            }
          }
        },
        grid: {
          left: 40,
          right: 20,
          top: 40,
          bottom: 30
        },
        series: [
          {
            name: '利润',
            type: 'line',
            smooth: false,
            symbol: 'circle',
            symbolSize: 6,
            data: yData,
            lineStyle: {
              width: 2,
              color: '#5FE1E0'
            },
            itemStyle: {
              color: '#5FE1E0',
              borderColor: '#fff',
              borderWidth: 1
            },
            areaStyle: {
              color: new echarts.graphic.LinearGradient(
                0, 0, 0, 1,
                [
                  { offset: 0, color: 'rgba(95,225,224,0.4)' },
                  { offset: 1, color: 'rgba(95,225,224,0)' }
                ],
                false
              )
            },
            label: {
              // show: true,
              // formatter: '{c}元'
              show: false
            }
          }
        ]
      }
    },
    getRateOptionrlu(rate_of_return) {
      const xData = rate_of_return.map(item => item.name)
      const yData = rate_of_return.map(item => parseFloat(item.value)) // 字符串转为数字

      return {
        title: { text: '回本率（%）' },
        tooltip: { trigger: 'axis' },
        xAxis: {
          type: 'category',
          data: xData,
          axisLine: { lineStyle: { color: '#E0E0E0' }},
          axisTick: { show: false },
          splitLine: { show: false }
        },
        yAxis: {
          type: 'value',
          axisLine: { show: false },
          axisTick: { show: false },
          axisLabel: {
            formatter: '{value}%'
          },
          splitLine: {
            lineStyle: {
              type: 'dashed',
              color: '#E0E0E0'
            }
          }
        },
        grid: {
          left: 40,
          right: 20,
          top: 40,
          bottom: 30
        },
        series: [
          {
            name: '回本率',
            type: 'line',
            smooth: false,
            symbol: 'circle',
            symbolSize: 6,
            data: yData,
            lineStyle: {
              width: 2,
              color: '#008DFF'
            },
            itemStyle: {
              color: '#008DFF',
              borderColor: '#fff',
              borderWidth: 1
            },
            areaStyle: {
              color: new echarts.graphic.LinearGradient(
                0, 0, 0, 1,
                [
                  { offset: 0, color: 'rgba(0,141,255,0.4)' },
                  { offset: 1, color: 'rgba(0,141,255,0)' }
                ],
                false
              )
            },
            label: {
              // show: true,
              // formatter: '{c}%' // 标签加上百分号
              show: false
            }
          }
        ]
      }
    },
    getMonthlyChartOption(monthIndex, chartData = {}) {
      const getMonthKey = (prefix) => `${prefix}${monthIndex}`

      const rechargeData = chartData[getMonthKey('order_money_month')] || []
      const rateData = chartData[getMonthKey('rate_of_return_month')] || []
      const scRateData = chartData[getMonthKey('sc_rate_of_return_month')] || []
      const fcRateData = chartData[getMonthKey('fc_rate_of_return_month')] || []

      // X轴的 name 统一提取
      const xAxisData = rechargeData.map(item => item.name)

      // Y轴数据（处理百分比字符串）
      const format = (arr) => xAxisData.map(name => {
        const item = arr.find(d => d.name === name)
        return item ? parseFloat(item.value.replace('%', '')) : 0
      })

      return {
        tooltip: {
          trigger: 'axis'
        },
        legend: {
          data: ['充值金额', '充值回本率', '首充回本率', '复充回本率']
        },
        xAxis: {
          type: 'category',
          data: xAxisData
        },
        yAxis: {
          type: 'value'
        },
        series: [
          {
            name: '充值金额',
            type: 'line',
            data: rechargeData.map(item => parseFloat(item.value))
          },
          {
            name: '充值回本率',
            type: 'line',
            data: format(rateData)
          },
          {
            name: '首充回本率',
            type: 'line',
            data: format(scRateData)
          },
          {
            name: '复充回本率',
            type: 'line',
            data: format(fcRateData)
          }
        ]
      }
    },
    getMonthlyChartOptionda(monthIndex, chartData = {}) {
      const getMonthKey = (prefix) => `${prefix}${monthIndex}`

      const rechargeData = chartData[getMonthKey('order_money_month')] || []
      const rateData = chartData[getMonthKey('rate_of_return_month')] || []
      const scRateData = chartData[getMonthKey('sc_rate_of_return_month')] || []
      const fcRateData = chartData[getMonthKey('fc_rate_of_return_month')] || []

      const xAxisData = rechargeData.map(item => item.name)

      const formatPercent = (arr) =>
        xAxisData.map(name => {
          const item = arr.find(d => d.name === name)
          return item ? parseFloat(item.value.replace('%', '')) : 0
        })

      return {
        grid: {
          left: '3%',
          right: '4%',
          bottom: '5%',
          containLabel: true
        },
        tooltip: {
          trigger: 'axis',
          formatter: function(params) {
            let str = `${params[0].axisValue}<br/>`
            params.forEach(item => {
              const isRate = item.seriesName.includes('回本率')
              str += `${item.marker} ${item.seriesName}: ${item.data.toFixed(2)}${isRate ? '%' : ''}<br/>`
            })
            return str
          }
        },
        legend: {
          top: 10,
          data: ['充值金额', '充值回本率', '首充回本率', '复充回本率']
        },
        xAxis: {
          type: 'category',
          data: xAxisData,
          axisLine: { lineStyle: { color: '#ccc' }}
        },
        yAxis: {
          type: 'value',
          axisLabel: {
            formatter: '{value}'
          }
        },
        series: [
          {
            name: '充值金额',
            type: 'line',
            smooth: true,
            symbol: 'circle',
            symbolSize: 6,
            lineStyle: { color: '#FF7C2E' },
            data: rechargeData.map(item => parseFloat(item.value))
          },
          {
            name: '充值回本率',
            type: 'line',
            smooth: true,
            symbol: 'circle',
            symbolSize: 6,
            lineStyle: { color: '#FFB500' },
            areaStyle: {
              color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                { offset: 0, color: '#FFB500' },
                { offset: 1, color: 'rgba(255, 181, 0, 0)' }
              ])
            },
            data: formatPercent(rateData)
          },
          {
            name: '首充回本率',
            type: 'line',
            smooth: true,
            symbol: 'circle',
            symbolSize: 6,
            lineStyle: { color: '#45D1D1' },
            areaStyle: {
              color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                { offset: 0, color: '#45D1D1' },
                { offset: 1, color: 'rgba(69, 209, 209, 0)' }
              ])
            },
            data: formatPercent(scRateData)
          },
          {
            name: '复充回本率',
            type: 'line',
            smooth: true,
            symbol: 'circle',
            symbolSize: 6,
            lineStyle: { color: '#1D79FB' },
            areaStyle: {
              color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                { offset: 0, color: '#1D79FB' },
                { offset: 1, color: 'rgba(29, 121, 251, 0)' }
              ])
            },
            data: formatPercent(fcRateData)
          }
        ]
      }
    },
    sewqawr() {
      this.newtubiao()
    },
    cellStyle({ row, column, rowIndex, columnIndex }) {
      // 根据列名判断颜色
      if (column.property === 'date' || column.property === 'order_money' || column.property === 'account_recharge' || column.property === 'tcbi' || column.property === 'profitability') {
        return { background: '#F5F7FB' } // 橙色
      }
      return {}
    },
    headerCellStyle({ column, columnIndex }) {
      if (
        column.property === 'date' ||
        column.property === 'order_money' ||
        column.property === 'account_recharge' ||
        column.property === 'tcbi' ||
        column.property === 'profitability' ||
        columnIndex === 0
      ) {
        return { backgroundColor: '#F5F7FB' }
      }
      return { backgroundColor: '#F5F7FB' }
    },
    async querySearchAsync(queryString, cb) {
      const data = await getFictionList({ name: queryString || null })
      const newss = data.data.list.map((item) => {
        return {
          value: `${item.name} (${item.platform})`,
          address: item.id
        }
      })
      cb(newss)
    },
    handleSelect(item) {
      this.selectQueryData.novel_id = item.address
    },
    async oplistr() {
      const res = await commonreportoptions()
      this.optionstoufang = res.data.launch_platform_type
    }
  }
}
</script>

<style scoped lang="less">
.reportMonth {
  // min-width: 1200px;
  // padding: 30px 60px;
  // padding: 0 20px;
  .titles {
      display: flex;
      align-items: center;
      padding-top:10px;
      padding-bottom:30px;
      font-weight:normal;
      label {
        padding: 5px 10px;
        border: 1px solid #eee;
      }
    }
  main {
    font-weight: 700;
    .form-top {
      width:100%;
      display: flex;
      justify-content: space-between;
      div {
        img {
          width: 16px;
          height: 16px;
          margin-right: 3px;
        }
      }
      .table-label {
        span {
          color: #86909c;
          font-weight:normal;
          margin-left: 10px;
        }
      }
    }
    .form {
      display: flex;
      padding-bottom: 20px;
      background: #fff;
      border-bottom: none;
      .switch {
        color: #fff;
        position: absolute;
        top: 2px;
        left: 7px;
      }
      .aggregateData {
        span {
          color: #9d2631;
        }
      }
    }
    .magRig {
      margin-right: 10px;
    }
    .magLfte {
      margin-left: 10px;
    }
    .green {
    }
    .yellow {
    }
  }
}
.el-card__body {
  .total-cell {
    width: 100%;
    height: 56px;
    display: flex;
    align-items: center;
    justify-content: center;
    border-right:1px solid rgba(231, 231, 231, 1);

    .total-img {
      img {
        width: 56px;
        height: 56px;
      }
    }
    .total-data {
      font-size: 18px;
      color: #1d2129;
      display: flex;
      flex-direction: column;
      height: 100%;
      margin-left: 10px;
      justify-content: space-between;

      div:nth-of-type(1) {
        font-size: 16px;
        color: #4e5969;
      }
      div:nth-of-type(2) {
        font-weight: bold;
      }
      span {
        font-size: 16px;
      }
    }
  }
  .total-cell:last-of-type{
    border-right:none;
  }
}
.total-box{
  margin: 16px 0px;
}
.chart-layout {
  padding-top: 16px;
  display: flex;
  flex-wrap: wrap;
  gap: 16px; /* 上下左右间距统一 */
  background-color: #f1f2f5;
}
.chart-item {
  flex: 1 1 calc(50% - 16px); /* 每行两个，减去gap */
  height: 426px;
  padding: 20px;
  border-radius: 5px;
  background: #fff;
  box-sizing: border-box; /* 避免padding影响宽度计算 */
}
.blue{
  font-weight:bold;
  margin-right:20px;
}

</style>
